import React, { useMemo, useState } from "react";
import { Box } from "@mui/material";
import { ParagraphText, UBRadioBox } from "../../../../Libraries";
import TabAutoComplete from "../../../../Libraries/TabAutoComplete";
import AddCustomerModal from "../../../common/Modals/AddCustomerModal";
import { PaymentMethodToggle } from "../../../common";
import { useNavigate } from "react-router-dom";
import { analytics, triggerLogEvent } from "../../../../config/firebase";
import { phoneNumRegex } from "../../../../validations";
import { useSnackbar } from "../../../../context/SnackbarContext";
import { formatNum } from "../../../../oscar-pos-core/constants";
import { updatedPaymentMethods } from "../../../../constants";
import moment from "moment";
import styles from "./BillPayments.module.css";
import formStyles from "../../SaleExpense/SaleExpenseForm/styles.module.css";
import { CoinIcon } from "../../../../assets/icons/icon";
const BillReviewSection = ({
  I18n,
  billInqueryData,
  icon,
  isPaidBill,
  customers = [],
  state,
  setState,
  setCustomer,
  categoryList = [],
  balance,
  balanceLoading = false,
  earnPoints = 0,
}) => {
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();
  const [createCustomerModal, setCreateCustomerModal] = useState(false);
  const [initName, setInitname] = useState("");
  const [initPhone, setInitphone] = useState("");
  const [contactToUpdate, setContactToUpdate] = useState(null);

  const amount = billInqueryData?.bill_amount || 0;
  const consumerName = billInqueryData?.consumer_name || "";
  const consumerNumber = billInqueryData?.consumer_number || "";
  const dueDate = billInqueryData?.bill_deadline
    ? moment(billInqueryData.bill_deadline).format("DD MMM YYYY")
    : "";
  const isInsufficient = !balanceLoading && !isPaidBill && balance < amount;

  const contactList = useMemo(
    () =>
      (customers || []).map((item) => ({
        id: item.id,
        labelText: item.name,
        label: (
          <ParagraphText className={formStyles.contactLabel}>
            <span className="newFontColor">{item.name}</span>
            <span className="newLightColor">
              {item?.is_supplier ? I18n.supplier : I18n.customer}
            </span>
          </ParagraphText>
        ),
        value: item.name,
      })),
    [customers, I18n],
  );

  const categoryOptions = useMemo(
    () =>
      (categoryList || []).map((item) => ({
        id: item.id,
        labelText: item.label || item.name,
        label: (
          <ParagraphText className={formStyles.contactLabel}>
            <span className="newFontColor">{item.label || item.name}</span>
          </ParagraphText>
        ),
        value: item.label || item.name,
      })),
    [categoryList],
  );

  const handleCreateContact = (value) => {
    if (value?.match?.(phoneNumRegex) === null) {
      setInitname(value);
      setInitphone("");
    } else {
      setInitphone(value);
      setInitname("");
    }
    setCreateCustomerModal(true);
  };

  const handleAddCustomer = (payload) => {
    setCreateCustomerModal(false);
    setContactToUpdate(null);
    const c = (customers || []).find((x) => x.id === payload?.id) || payload;
    setCustomer(c);
    setState((e) => ({ ...e, contactName: c?.name || "" }));
  };

  return (
    <Box className={styles.reviewWrapper}>
      <Box className={styles.amountCard}>
        <ParagraphText className={`fontSize14 newLightColor ${styles.amountLabel}`}>
          {I18n.amount}
        </ParagraphText>
        <Box className={styles.amountRow}>
          <ParagraphText className={`fontSize24 fontWeight600 newFontColor ${styles.amountValue}`}>
            Rs. {formatNum(amount)}
          </ParagraphText>
          {isPaidBill && (
            <Box className={styles.paidBadge}>
              <ParagraphText className="fontSize12 fontWeight400">
                {I18n.paid}
              </ParagraphText>
            </Box>
          )}
        </Box>

        <Box className={styles.billDetailRow}>
          {icon && (
            <Box className={styles.billDetailIconWrapper}>
              <img src={icon} alt="" className={styles.billDetailIcon} />
            </Box>
          )}
          <Box className={styles.billDetailText}>
            <ParagraphText className="fontSize14 newFontColor">
              {consumerNumber}
            </ParagraphText>
            {consumerName ? (
              <ParagraphText className="fontSize14 newLightColor">
                {consumerName}
              </ParagraphText>
            ) : null}
          </Box>
          {dueDate ? (
            <ParagraphText className={`fontSize14 newLightColor ${styles.dueDate}`} dir="auto">
              {I18n.due} : {dueDate}
            </ParagraphText>
          ) : null}
        </Box>

        {!isPaidBill && earnPoints ? (
          <Box className={styles.earnPointsRow}>
            <CoinIcon />
            <ParagraphText className="fontSize14 newFontColor">
              {I18n.you_will_earn}{" "}
              {earnPoints} {I18n.points}
            </ParagraphText>
          </Box>
        ) : null}

        {isInsufficient && (
          <ParagraphText className={`fontSize12 ${styles.insufficientText}`}>
            {I18n.insufficient_balance_please_try_different_amount}
          </ParagraphText>
        )}
      </Box>

      {!isPaidBill && (
        <Box className={styles.reviewFields}>
          <Box className={`${formStyles.tabAutoCompleteBox} tabAutoCompleteBox`}>
            <TabAutoComplete
              id="bill_review_contact"
              list={contactList}
              label={I18n.contact}
              handleSelect={(item) => {
                if (!item) {
                  setCustomer(null);
                  setState((e) => ({ ...e, contactName: "" }));
                  return;
                }
                triggerLogEvent(analytics, "w_earn_bill_customer");
                const c = (customers || []).find((x) => x.id === item.id);
                if (c?.phone) {
                  setCustomer(c);
                  setState((e) => ({ ...e, contactName: c?.name || item.labelText || "" }));
                } else {
                  setContactToUpdate(c);
                  showSnackbar({ message: I18n.please_add_a_phone_number_to_continue, severity: "info" });
                  setCreateCustomerModal(true);
                }
              }}
              value={state.contactName || ""}
              handleCreate={handleCreateContact}
              asCreate="contact"
              placeholder={I18n.select_a_contact}
              handleStartLogEvent={() => {}}
              manuallyFocusInput={false}
              handleManuallyInput={() => {}}
            />
          </Box>

          <Box className={`${formStyles.tabAutoCompleteBox} tabAutoCompleteBox`}>
            <TabAutoComplete
              id="bill_review_category"
              list={categoryOptions}
              label={I18n.select_category}
              handleSelect={(item) => {
                setState((e) => ({
                  ...e,
                  expenseCategory: item?.labelText || item?.value || "",
                  expenseCategoryId: item?.id || "",
                }));
              }}
              value={state.expenseCategory || ""}
              placeholder={I18n.select_category}
              handleStartLogEvent={() => {}}
              manuallyFocusInput={false}
              handleManuallyInput={() => {}}
            />
          </Box>

          {state.contactName && (
            <Box className={`paymentStatusBoxWrapper ${formStyles.paymentStatusBoxWrapper}`}>
              <Box className={formStyles.paymentStatusBox}>
                <Box className={formStyles.paymentStatusBoxLeft}>
                  <UBRadioBox
                    label={"Paid"}
                    displayLabel={I18n.paid}
                    onChange={(value) => {
                      triggerLogEvent(analytics, "w_earn_bill_paid");
                      setState((e) => {
                        const next = { ...e, paymentStatus: value };
                        if (!e.paymentMode) {
                          next.paymentMode =
                            updatedPaymentMethods.find((m) => m.name === "bank")
                              ?.display_name || "Bank";
                        }
                        return next;
                      });
                    }}
                    value={state.paymentStatus}
                  />
                  <UBRadioBox
                    label={"Unpaid"}
                    displayLabel={I18n.unpaid}
                    onChange={(value) => {
                      triggerLogEvent(analytics, "w_earn_bill_unpaid");
                      setState((e) => ({ ...e, paymentStatus: value }));
                    }}
                    value={state.paymentStatus}
                  />
                </Box>
                <Box className={formStyles.paymentStatusBoxRight}>
                  <PaymentMethodToggle
                    idPrefix="bill_review_payment_method"
                    visible={
                      (state.paymentStatus || "").toLocaleLowerCase() === "paid"
                    }
                    value={(state.paymentMode || "").toLowerCase() || null}
                    onChange={(method) => {
                      triggerLogEvent(analytics, "w_earn_bill_payment_method", {
                        method: method?.name || method?.display_name || "",
                      });
                      setState((e) => ({
                        ...e,
                        paymentMode: method?.display_name || method?.name || "Bank",
                      }));
                    }}
                  />
                </Box>
              </Box>
            </Box>
          )}

        </Box>
      )}

      <AddCustomerModal
        isOpen={createCustomerModal}
        handleClose={() => {
          setCreateCustomerModal(false);
          setContactToUpdate(null);
        }}
        navigate={navigate}
        initialName={initName}
        initialPhone={initPhone}
        onSaveCallback={handleAddCustomer}
        type="in"
        title={
          <ParagraphText className="ms-1 textLowercase">{I18n.customer}</ParagraphText>
        }
        isTypeField={false}
        handleLogEventCustomerCreated={() =>
          triggerLogEvent(analytics, "w_earn_bill_customer_created")
        }
        handleLogEventCustomerUpdate={() =>
          triggerLogEvent(analytics, "customer_data_updated")
        }
        isOnlyPhoneList={true}
        customerToUpdate={contactToUpdate}
      />
    </Box>
  );
};

export default BillReviewSection;
